export default function (caseNumber) {
  return {
    name: "Respond to Notice of Deficiency",
    pageInfo: {
      text: "Please upload the response to your Notice of Deficiency below. Your response will be added to the case documents and directed to an analyst for review.",
      coloring: "grey",
    },
    sections: [
      {
        fields: [
          {
            machine_name: "fileType",
            widget: "text",
            value: "NOD Response",
            style: {
              display: "none",
            },
          },
          {
            machine_name: "Request_Redetermination_Case_Number",
            widget: "text",
            label: "Case Number *",
            maxLength: 100,
            disabled: true,
            value: caseNumber || "",
          },
          {
            machine_name: "files",
            widget: "file_upload",
            file_upload: { fileType: "NOD_Response_Document_Upload" },
            accept_multiple: false,
            required: true,
            validate: ["required", "file_required"],
            checkFilesAdded: true,
            documentAuth: "dh",
          },
          {
            machine_name: "document_description",
            widget: "text",
            label: "Document Description",
            validate: ["required"],
            maxLength: 100,
          },
          // {
          //     machine_name: 'case_note',
          //     widget: 'text_area',
          //     label: 'Case Note',
          //     inputLimit: 400,
          //     rows: 7
          // }
        ],
      },
    ],
  };
}
